<template>
    <div>
			<!--面包屑导航区域-->
            <div class="crumbs">
            	<el-breadcrumb separator="/">
				<el-breadcrumb-item>
              <i class="el-icon-lx-group"></i> 家长管理
			  </el-breadcrumb-item>
            </el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query" >
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-input v-model="query.phone" clearable :placeholder="'请输入手机号'" class="handle-input mr10" style="width: 15%;"></el-input>
								<el-input v-model="query.name" clearable :placeholder="'请输入家长姓名'" class="handle-input mr10" style="width: 15%;"></el-input>
								<el-select v-model="query.valueHAAGSEX" clearable 
								:placeholder="'请选择性别'" class="handle-select mr10" style="width: 15%;">
								  <el-option
								  	v-for="item in query.optionsHAAGSEX"
								  	:key="item.INIKEY2"
								  	:label="item.INIDISP"
								  	:value="item.INIKEY2">
								  </el-option>
								</el-select>
								<!-- <el-select v-model="query.stat" clearable filterable :placeholder="'请选择删除状态'" class="select-shop mr10">
									<el-option v-for="item in query.optionsStat" :key="item.INIKEY2" :label="item.INIDISP" :value="item.INIKEY2"></el-option>
								</el-select> -->
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="warning" :disabled="!hasPerms(buttonPerms.searchPerms)" class="float" icon="el-icon-search"@click="handleSearch">搜索</el-button>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!-- <el-button type="danger" :disabled="!hasPerms(buttonPerms.batchdelPerms)" icon="el-icon-delete" class="handle-del" @click="delAllSelection">批量删除</el-button> -->
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
								<el-button type="primary" :disabled="!hasPerms(buttonPerms.addPerms)" icon="el-icon-plus" @click="handleAdd">添加家长</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
				
				<el-table :data="tableData" border class="table" :default-sort="{prop: 'HAAINDT', order: 'descending'}"
				 header-cell-class-name="table-header" @selection-change="handleSelectionChange" :row-key="getRowKeys" v-loading="loading">
					<el-table-column type="index" :label="'序号'" width="80" align="center"></el-table-column>
					<el-table-column prop="HAAMSID" :label="'ID'"align="center" v-if='show' width="150"></el-table-column>
					<el-table-column prop="HAAPHON" :label="'手机号'" align="center" ></el-table-column>
					<el-table-column prop="HAANAME" :label="'姓名'" align="center" ></el-table-column>
					<el-table-column prop="HAAGSEX" :label="'性别'"align="center"  width="120">
						<template slot-scope="scope">
							<span style="display: block;">
								{{scope.row.HAAGSEX.name}}
							</span>
							
						</template>
					</el-table-column>
					<el-table-column prop="HAABIRT" :label="'生日'" :formatter="dateFormatter" align="center" width="150"></el-table-column>
					<!-- <el-table-column :label="'删除状态'" align="center" width="120">
					<template slot-scope="scope">
						<span style="display: block;">
							{{scope.row.HAADELF.name}}
						</span>					
					</template>
					</el-table-column> -->
					<el-table-column :label="'操作'"  align="center" width="200">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-edit" @click="dialogVisible = true;setPSWD(scope.$index, scope.row)">重置密码</el-button>
							<el-dialog
							  title="提示"
							  :visible.sync="dialogVisible"
							  width="30%"
							  :before-close="handleClose">
							  <span>确定将该家长登录密码重置成[123456]吗？</span>
							  <span slot="footer" class="dialog-footer">
							    <el-button @click="dialogVisible = false">取 消</el-button>
							    <el-button type="primary" @click="dialogVisible =false;handleResetPSWD()">确 定</el-button>
							  </span>
							</el-dialog>
							<el-button type="text" :disabled="!hasPerms(buttonPerms.editPerms)" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
							<!-- <el-button type="text" :disabled="!hasPerms(buttonPerms.deletePerms)" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-pagination background layout="total, prev, pager, next, jumper" :current-page="this.query.pageIndex"
					 :page-size="this.query.pageSize" :total="this.pageTotal" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
				</div>
			</el-form>
		</div>
    </div>
</template>
<script>
import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'parentList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					addPerms: 'parent:parentList:add', //新增权限标识
					searchPerms: 'parent:parentList:search', //搜索权限标识
					editPerms: 'parent:parentList:edit', //编辑权限标识
					deletePerms: 'parent:parentList:delete', //删除权限标识
					batchdelPerms: 'parent:parentList:batchdel', //批量删除权限标识

					disabled: false
				},
				
				web_suuid: sessionStorage.getItem("ms_web_suuid"), 
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户
				
				dialogVisible: false,
				msid:'',
				query: {
					phone: '',
					stat: '',
					valueHAAGSEX:'',
					optionsHAAGSEX: '',
					optionsStat: '',
					name: '',
					pageIndex: 1, //当前页
					pageSize: 10 //这是当前每页显示的条数
				},
				tableData: [],
				multipleSelection: [], // 多选操作
				delList: [],
				pageTotal: 0, // 总条数
				loading: false,
				typeAll: [],
				ULIDLabelNameFlag: true // 无跳转链接时删除输入框
			};
		},
		created() {
			let curpagenum = this.query.pageIndex; //当前页码
			this.show=false;
			this.getGSEX();
			//this.getStat();
			this.getData(curpagenum); //获取当前列表数据
			this.Get_HAA_List_Count(); //获取当前列表条数
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			handleClose(done) {
			     this.$confirm('确认关闭？')
			       .then(_ => {
			         done();
			       })
			       .catch(_ => {});
			},
			//获取状态
			getStat() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10005 //店铺分类状态  10017
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsStat = response.data.KKDT;
							response.data.KKDT.forEach((team, index) => {
								this.query.optionsStat[index].name = team.INIDISP;
								this.query.optionsStat[index].SBASTAT = team.INIKEY2;
							})
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取删除状态失败', //请求失败
							type: 'error'
						});
					});
			},
			//获取性别
			getGSEX() {
				const self_shop = this;
				var postUrl = 'WCF/WEB/svcINI.svc/Get_INI_List';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_shop.web_sphon, //web侧 登录邮箱
							sINIKEY1: 10001 //性别 10001
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.query.optionsHAAGSEX = response.data.KKDT;
							response.data.KKDT.forEach((team, index) => {
								this.query.optionsHAAGSEX[index].name = team.INIDISP;
								this.query.optionsHAAGSEX[index].HAAGSEX = team.INIKEY2;
							})
						}
					})
					.catch((error) => {
						this.$message({
							message: '获取性别失败', //请求失败
							type: 'error'
						});
					});
			},
			// 日期格式化
			dateFormatter (row, column) {
				var t = new Date(row.HAABIRT); //row 表示一行数据, date 表示要格式化的字段名称
				var year = t.getFullYear(),
					month = t.getMonth() + 1,
					day = t.getDate();
				var newDate = year + '-' +
					(month < 10 ? '0' + month : month) + '-' +
					(day < 10 ? '0' + day : day);
					
				if(row.HAABIRT)
				{
					return newDate
				}
			    else{
					return ''
				}		
			},
			// 获取当前列表条数
			Get_HAA_List_Count() {
				const self_count = this;
				var postUrl = 'WCF/WEB/svcHAA.svc/Get_HAA_List_Count';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sHAAPHON: self_count.query.phone.trim(),
							sTITL: self_count.query.name.trim(),
							sGSEX: self_count.query.valueHAAGSEX,
							sSTAT: self_count.query.stat
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						this.pageTotal = Number(resCount); //总条数
					})
					.catch((error) => {
						this.$message({
							message: '获取家长信息失败', //请求失败
							type: 'error'
						});
					});
			},
			// 获取用户数据
			getData(curpage) {
				this.loading = true; //初始化加载loading效果
				const self_count = this;
				var postUrl = 'WCF/WEB/svcHAA.svc/Get_HAA_List';
				//debugger;
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sHAAPHON: self_count.query.phone.trim(),
							sTITL: self_count.query.name.trim(),
							sGSEX: self_count.query.valueHAAGSEX,
							sSTAT: self_count.query.stat,
							sPageIndex: curpage, //页码
							sPageSize: self_count.query.pageSize //每页显示条数
					
						})
					.then((response) => {
						this.loading = false; //取消loading效果
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						let resKKDT = response.data.KKDT;
						if (resCount > 0) {
							resKKDT.forEach((team, index) => {
								if (team.HAADELF === '0') {
									resKKDT[index].HAADELF = {
										HAADELF: '0',
										name: '有效'
									};
								} else if (team.HAADELF === '1') {
									resKKDT[index].HAADELF = {
										HAADELF: '1',
										name: '删除'
									};
								}
								if (team.HAAGSEX === '0') {
									resKKDT[index].HAAGSEX = {
										HAAGSEX: '0',
										name: '女'
									};
								} else if (team.HAAGSEX === '1') {
									resKKDT[index].HAAGSEX = {
										HAAGSEX: '1',
										name: '男'
									};
								}
							})
							//渲染数据 List
							this.tableData = resKKDT; //数据数组
							//console.log(resKKDT);
						} else {
							this.tableData = []; //数据数组
						}
					})
					.catch((error) => {
						this.loading = false; //取消loading效果
						this.$message({
							message: '获取家长信息失败', //请求失败
							type: 'error'
						});
					});

			},
			// 触发搜索按钮
			handleSearch() {
				this.$set(this.query, 'pageIndex', 1);

				this.getData(1);
				this.Get_HAA_List_Count(); //获取当前列表条数
			},
			// 触发新增按钮
			handleAdd() {
				//this.$router.push('/addParent'); // 跳转路由
				this.$router.push({
					name: 'addParent',
					query: {
						eaaid: this.$route.query.uid,
					}
				})
				this.$bus.$emit('change')
			},
			setPSWD(index, row){
				const self_count = this;
				self_count.msid=row.HAAMSID;
			},
			handleResetPSWD(){
				const self_count = this;
				var postUrl = 'WCF/WEB/svcHAA.svc/Upd_HAA_Pswd';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_count.web_sphon, //web侧 登录ID  tihs.web_suuid
							sMSID: self_count.msid,
							sPSWD: this.$md5('123456')
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resStatus = response.status; //200 代表请求成功
						let resKKSTR = response.data.KKSTR;
					
						if (resStatus == "200") {
							if (resKKSTR == "N") {
								this.$message({
									message: '重置密码失败', //编辑失败
									type: 'error'
								});
							} else if (resKKSTR == "Y") {
								this.$message.success('登录密码重置成功'); // 编辑成功
							}
						} else {
							this.$message({
								message: '登录密码重置请求失败', //请求失败
								type: 'error'
							});
						}
					})
					.catch((error) => {
						this.$message({
							message: '登录密码重置请求失败', //请求失败
							type: 'error'
						});
					});
				
			},
			// 编辑操作
			handleEdit(index, row) {
				this.idx = index;
				// 跳转路由
				this.$router.push({
					name: 'editParent',
					query: {
						HAAMSID: row.HAAMSID
					}
				})
				//this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload
			},
			// 删除
			handleDelete(index, row) {
				
				// 二次确认删除
				this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						//删除接口
						const self = this;
						var postUrl = 'WCF/WEB/svcHAA.svc/DEL_HAA_LIST';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
									HAAMSID: [row.HAAMSID] //uid
								}
							)
							
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '数据删除失败', //删除失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('数据删除成功'); //删除成功
										this.tableData.splice(index, 1);

										//刷新当前页面
										this.reload()
									}
								} else {
									this.$message({
										message: '删除请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '删除请求失败', //请求失败
									type: 'error'
								});
							});
					})
			},
			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 批量删除
			delAllSelection() {
				const length = this.multipleSelection.length;

				if (length > 0) {
					let ID = [];
					this.delList = this.delList.concat(this.multipleSelection);
					for (let i = 0; i < length; i++) {
						ID.push(this.multipleSelection[i].HAAMSID);
					}
					this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
							type: 'warning'
						})
						.then(() => {

							//批量删除接口
							const self = this;
							var postUrl = 'WCF/WEB/svcHAA.svc/DEL_HAA_LIST';
							//网络请求接口
							this.$axios.post(
									//请求的url
									postUrl,
									//请求参数
									{
										sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid
										HAAMSID: ID //uid
									}
								)
								.then((response) => {
									//请求成功返回的数据
									let resStatus = response.status; //200 代表请求成功
									let resKKSTR = response.data.KKSTR;

									if (resStatus == "200") {
										if (resKKSTR == "N") {
											this.$message({
												message: '数据删除失败', //删除失败
												type: 'error'
											});
										} else if (resKKSTR == "Y") {
											this.$message.success('数据删除成功'); //批量删除成功
											this.multipleSelection = [];

											//刷新当前页面
											this.reload()
										}
									} else {
										this.$message({
											message: '删除请求失败', //请求失败
											type: 'error'
										});
									}

								})
								.catch((error) => {
									this.$message({
										message: '删除请求失败', //请求失败
										type: 'error'
									});
								});

						})
				} else {
					this.$confirm('请选择要删除的数据', {
							type: 'warning'
						})
						.then(() => {})
						.catch(() => {});
				}
			},
			// 分页导航 currentPage 改变时会触发
			handlePageChange(currentPage) {
				this.$set(this.query, 'pageIndex', currentPage);
				// 调取列表的函数，初始化时调一次
				this.getData(currentPage);
			},
			//pageSize 改变时会触发
			handleSizeChange(size) {
				this.$set(this.query, 'pageIndex', 1);
				this.$set(this.query, 'pageSize', size);
				// 调取列表的函数，初始化时调一次
				this.getData(size);
			},
			getRowKeys(row) {
				return row.HAAMSID; // id为列表数据的唯一标识
			},
			
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 250px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>